// extracted by css-extract-rspack-plugin
export default {"container":"container-Sv3SU8"};